import { AnyAction } from 'redux';
import localstore from 'store';

import { STORAGE_KEYS } from '../../helpers/useStorage';
import { Thunk } from '../../interfaces/State';
import { DAILY_XP_GOAL } from '../reducers/streakInfo';
import * as selectors from '../selectors';
import { MODAL_TYPE } from '../selectors';

import { showModal } from './settings';

export const checkDailyStreak = ({
  nextStep,
}: {
  nextStep?: AnyAction;
}): Thunk => (dispatch, getState) => {
  const streakInfo = selectors.selectStreakInfo(getState());

  if (
    streakInfo.type === 'StreakUnknown' ||
    streakInfo.dailyXp <= DAILY_XP_GOAL
  ) {
    if (nextStep) dispatch(nextStep);
    return;
  }

  const streakIncrementedAt = Date.parse(streakInfo.incrementedAt ?? '') || 0;

  const lastSeenAt =
    Date.parse(localstore.get(STORAGE_KEYS.STREAK_MODAL_SEEN) || '') || 0;

  if (
    !streakIncrementedAt ||
    (lastSeenAt && lastSeenAt >= streakIncrementedAt)
  ) {
    if (nextStep) dispatch(nextStep);
    return;
  }

  localstore.set(STORAGE_KEYS.STREAK_MODAL_SEEN, `${streakInfo.incrementedAt}`);

  dispatch(
    showModal({
      modal: {
        code: MODAL_TYPE.DAILY_STREAK_REACHED.code,
        nextStep,
      },
    }),
  );
};
